import(/* webpackMode: "eager", webpackExports: ["ShopCategoriesScreen"] */ "/app/apps/landing-app/src/screens/ShopScreen/ShopCategoriesScreen.tsx");
